__webpack_require__.p = "/reports-dashboard-templates-origin/referrals-hub/";